var keepAliveCallback = function keepAliveCallback(_ref) {
  var _ref$data = _ref.data,
      type = _ref$data.type,
      uuid = _ref$data.uuid;

  if (type === 'keepAlive' && uuid === window.WF_CHATBOT.uuid) {
    window.WF_SESSION.keepAlive();
  }
};
/**
 * Adds event listener to keep page alive.
 */


export var addKeepAliveEvent = function addKeepAliveEvent() {
  window.WFUI_BRIDGE.registerEventListener('keepAlive', keepAliveCallback, window.WF_CHATBOT.uuid);
};